var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.activeIndex,"useZoomBar":true,"slideshow":false},on:{"close":function($event){return _vm.closeLightBox()},"on-open":function($event){return _vm.openLightBox()}}})}
var staticRenderFns = []

export { render, staticRenderFns }